module.exports = __webpack_public_path__ + "img/JLL-Logo.2ea13777.png";